<template>
  <div class="main-container narrow">
    <div class="form main-container-item">
      <div class="form__container">
        <Logo />
        <div class="title">All Set!</div>
        <div class="subtitle">Ready to create something?</div>
        <iframe style="margin-top:12px;" width="640" height="360" src="https://www.youtube.com/embed/W6vMWDSSiE0" title="ENKLU - Creating your first Experience" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <button
          class="btn"
          type="button"
          style="margin: 48px auto;"
          @click.prevent="signIn">
          Sign In
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/Logo.vue";

export default {
  components: { Logo },
  methods: {
    signIn() {
      window.location.href='https://cloud.enklu.com';
    }
  }
}
</script>